import React from "react"
import PropTypes from "prop-types"

import ComparatorRow from "./ComparatorRow"

const ComparatorTable = ({ filas, esLocal, ...rowProps }) => (
  <div className="pv2-table-scroll">
    <div className="pv2-table">
      <div className="pv2-grid pv2-thead">
        <div>Proveedor / Granja</div>
        <div>Producto</div>
        <div className="pv2-right is-dim">Disponible</div>
        <div className="pv2-right is-dim">Peso prom.</div>
        <div className="is-dim">Pig · Cal · Salud</div>
        <div className="pv2-right">
          {esLocal ? "P. Granja / pza" : "P. Destino / pza"}
        </div>
        <div className="pv2-right is-dim">Δ mejor</div>
        <div className="is-dim">Recepción</div>
        <div className="pv2-right">Ordenar</div>
        <div className="pv2-right">Importe</div>
        <div />
      </div>

      {filas.map(fila => (
        <ComparatorRow key={fila.id} fila={fila} esLocal={esLocal} {...rowProps} />
      ))}

      {filas.length === 0 && (
        <div className="pv2-empty">Ninguna disponibilidad coincide con el filtro.</div>
      )}
    </div>
  </div>
)

ComparatorTable.propTypes = {
  filas: PropTypes.array.isRequired,
  esLocal: PropTypes.bool.isRequired,
}

export default ComparatorTable
